import RecipeService from '@/service/RecipeService';
const recipeService = new RecipeService();
export default {
    namespaced: true,
    state() {
        return {
            recipes : null
        }
    },
    getters: {
        recipes: state => {
            return state.recipes;
        },
    },
    mutations: {
       setRecipes: function(state , payload) {
            state.recipes = payload;
        },
    },
    actions: {
        async getRecipes(context, payload) {
            let response = await recipeService.getRecipes(payload.language);
            context.commit("setRecipes", response);
            return await response;
        },
    }
};